import { IConditionalProps } from "./conditional.interfaces";

/**
 * Conditionally render a wrapper.
 *
 * If the condition is true then it will return children wrapped in the provided element.
 * Otherwise it returns just children.
 *
 * @param condition Determines whether to render the wrapper
 * @param children Content to be wrapped
 * @param wrapper Function that returns an element to wrap the children
 */
const Conditional = ({ condition, children, wrapper }: IConditionalProps) =>
  condition ? wrapper(children) : children;

export { Conditional };
 